// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// material ui
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from '@mui/material';

// feature-components
import ServiceActivationSwitch from '@/features/service-manager/components/ServiceActivationSwitch';

export const Route = createFileRoute(
  '/$accountId/_user/account/services/datahub-integration',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('service-manager');
  const { accountId } = useParams({
    from: '/$accountId/_user/account/services/datahub-integration',
  });

  return (
    <Card>
      <CardHeader
        title={t('services.datahubIntegration.title')}
        action={
          <ServiceActivationSwitch
            managedAccountId={accountId}
            servicePath="datahub-integration"
            ariaLabel={t('services.datahubIntegration.title')}
          />
        }
        slotProps={{
          title: { variant: 'h6', fontWeight: 600 }
        }}
      />
      <Divider />
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {t('services.datahubIntegration.description')}
        </Typography>
      </CardContent>
    </Card>
  );
}

